// extracted by mini-css-extract-plugin
export default {"hengbeiLoading":"match-h5-animation_hengbeiLoading__UeUq+","loadingBox":"match-h5-animation_loadingBox__1zxk+","rotate":"match-h5-animation_rotate__AMm9D"};